import { z } from "zod";
export const UserStatsSchema = z.object({
    storiesCompleted: z.number().int().nonnegative(),
    choicesMade: z.number().int().nonnegative(),
    endingsUnlocked: z.number().int().nonnegative(),
    rareEndingsUnlocked: z.number().int().nonnegative(),
});
